import { useElementWidth } from 'lib/use-element-size'
import React, { FC, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { SliderHandle } from 'ui/range-slider/SliderHandle'

type RangeValue = { from: number; to: number }
type Props = {
  min: number
  max: number
  onChange?: (value: RangeValue) => void
  value: RangeValue
  onChangeEnd?: () => void
  single: boolean
}

export const Slider: FC<Props> = ({ min, max, onChange = () => {}, value, onChangeEnd, single }) => {
  const { from, to } = value

  const sliderRef = useRef<HTMLDivElement>(null)
  const width = useElementWidth(sliderRef)

  const pixelsInOneValue = width === null || max === min ? 0 : width / (max - min)

  const valueToX = (value: number) => Math.round(pixelsInOneValue * value)

  const xToValue = (x: number) => x / pixelsInOneValue + min

  // Lift value up, behave as controlled element
  const setValue = ({ from, to }: RangeValue) => onChange({ from, to })

  const onTrackClick = (e: React.MouseEvent<HTMLDivElement>) => {
    return false // todo: вернуть логику на место ). Проблема в том, что этот клик не вызывает on
    const value = xToValue(e.nativeEvent.offsetX)

    if (single) {
      setValue({ from: value, to })
      return
    }
    const distanceFromFrom = Math.abs(from - value)
    const distanceFromTo = Math.abs(to - value)

    if (distanceFromFrom < distanceFromTo) {
      setValue({ to, from: value })
    }

    if (distanceFromFrom > distanceFromTo) {
      setValue({ to: value, from })
    }

    if (distanceFromFrom === distanceFromTo) {
      if (value > to) setValue({ to: value, from })
      if (value < from) setValue({ to, from: value })
    }
  }

  return (
    <Wrapper single={single}>
      <SliderHandle
        type={single ? 'single' : 'left'}
        offsetLeft={valueToX(from - min)}
        onOffsetLeftChange={(e) => {
          setValue({
            from: xToValue(e),
            to
          })
        }}
        onDrop={onChangeEnd}
      />
      {!single && (
        <SliderHandle
          type="right"
          offsetLeft={valueToX(to - min)}
          onOffsetLeftChange={(e) => {
            setValue({
              from,
              to: xToValue(e)
            })
          }}
          onDrop={onChangeEnd}
        />
      )}
      <Track onPointerDown={onTrackClick} ref={sliderRef}>
        <TrackSector
          style={{
            transform: `translateX(${valueToX(single ? 0 : from - min) - 2}px)`,
            width: `${valueToX(single ? from - min : to - from) + 4}px`
          }}
        />
      </Track>
    </Wrapper>
  )
}

const Track = styled.div`
  user-select: none;
  position: absolute;
  left: ${({ theme }) => theme.spacing[4]};
  right: ${({ theme }) => theme.spacing[4]};
  height: ${({ theme }) => theme.spacing[1]};
  top: ${({ theme }) => theme.spacing[1]};
  background: ${({ theme }) => theme.palette.grey[200]};
`

const TrackSector = styled.div`
  pointer-events: none;
  position: absolute;
  background: ${({ theme }) => theme.palette.brand.primary};
  height: 4px;
`

const Wrapper = styled.div<{ single: boolean }>`
  height: ${({ theme }) => theme.spacing[4]};
  margin-left: ${({ single }) => (single ? '-0.8rem' : '')};
  padding: ${({ theme }) => `${theme.spacing[0]} ${theme.spacing[2]}`};
  position: relative;
`
